<style scoped>
    .fin-report-table /deep/ .date-pick-long{
        margin-bottom: 2px;
    }
</style>
<style>
    .fin-report-table .fin-report-0-row td{
        font-weight: bold;
        color: #222;
    }
    .fin-report-table .fin-report-1-row td{
        color: #222;
    }
</style>
<template>
    <div>
        <div class="color-error text-large">仪表盘迭代中</div>
        <Table border
           class="fin-report-table"
           disabled-hover
           ref="table"
           size="small"
           :height="table_height"
           :row-class-name="rowClassName"
           :no-data-text="no_data_text"
           :columns="table_columns"
           :data="table_rows"
           :loading="loading">
        </Table>
        <div class="line paginate-fix-bottom" v-show="table_rows.length">
            <Button type="primary" @click="exportCsv()">导出数据</Button>
        </div>
    </div>
</template>
<script>
    import Util from '../../libs/util';
    export default {
        props: ['type'],
        data () {
            return {
                params: {
                    month: '',
                    daterange: []
                },
                loading: false,
                table_height: window.innerHeight - 140,
                fin_teams: [],
                groups: [],
                none_group_teams: [],
                fin_expense_types: [],
                fin_expense_types_hash: {},
                //table_data: [],
                table_rows: [],
                //table_columns: [],
                fin_team_expense_hash: {},
                export_columns: []
            }
        },
        computed: {
            table_columns(){
                let columns = [
                    {
                        title: '费用类别',
                        key: 'name',
                        width: 190,
                        fixed: 'left',
                        align: 'center',
                        renderHeader: (h, params)=>{
                            let ret = [];
                            if(this.type === 'monthly'){
                                ret = [
                                    h('DatePicker', {
                                        attrs: {
                                            style: 'width: 100px',
                                            placeholder: '选择月份',
                                        },
                                        props: {
                                            size: 'small',
                                            type: 'month',
                                            editable: false,
                                            clearable: false,
                                            value: this.curMonth(),
                                            options: {
                                                disabledDate(date){
                                                    let now = new Date();
                                                    let disabledDateStart = new Date('2017-08-31').getTime();
                                                    let disabledDateEnd = new Date(`${now.getFullYear()}-${now.getMonth()}-01`).getTime();
                                                    return date && ( date.valueOf() < disabledDateStart || date.valueOf() > disabledDateEnd);
                                                }
                                            }
                                        },
                                        on: {
                                            'on-change': (month)=>{
                                                this.params.month = month;
                                                this.getReport();
                                            }
                                        }
                                    }),
                                    h('span', ' '),
                                    h('Button', {
                                        props: {
                                            size: 'small',
                                            type: 'primary'
                                        },
                                        on: {
                                            click: ()=>{
                                                this.getReport();
                                            }
                                        }
                                    }, '确定')
                                ];
                            }else if(this.type === 'dynamic'){
                                let now = moment();
                                let start = `${now.year()}-${now.month()+1}-01`;
                                let end = now.format('YYYY-MM-DD');
                                ret = `${start} 至 ${end}`;
                            }else if(this.type === 'dynamic_income'){
                                ret = [
                                    h('DatePicker', {
                                        'class': {
                                            'date-pick-long': true
                                        },
                                        attrs: {
                                            style: 'width: 100%',
                                            placeholder: '选择时间段',
                                        },
                                        props: {
                                            size: 'small',
                                            type: 'daterange',
                                            editable: false,
                                            clearable: false,
                                            'split-panels': true,
                                            value: this.curDaterange(),
                                            options: {
                                                disabledDate(date){
                                                    let now = new Date();
                                                    let disabledDateStart = new Date('2017-08-31').getTime();
                                                    let disabledDateEnd = new Date(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`).getTime() - 24 * 3600 * 1000;
                                                    return date && ( date.valueOf() < disabledDateStart || date.valueOf() >= disabledDateEnd);
                                                }
                                            }
                                        },
                                        on: {
                                            'on-change': (range)=>{
                                                this.params.daterange = range;
                                                this.getReport();
                                            }
                                        }
                                    }),
                                    h('Button', {
                                        props: {
                                            long: true,
                                            size: 'small',
                                            type: 'primary'
                                        },
                                        on: {
                                            click: ()=>{
                                                this.getReport();
                                            }
                                        }
                                    }, '确定')
                                ]
                            }else{
                                ret = '未定义仪表盘类型';
                            }
                            return h('div', ret);
                        },
                        render: (h, params)=>{
                            let row = params.row;
                            let ret = [];
                            ret.push(h('span', `${row.name} `));
                            if(row.name_tip){
                                ret.push(h('Tooltip', {
                                    props: {
                                        content: row.name_tip,
                                        transfer: true,
                                        placement: 'top'
                                    }
                                }, [
                                    h('Icon', {
                                        props: {
                                            type: 'md-help-circle',
                                            size: 12
                                        }
                                    })
                                ]));
                            }
                            if(row.has_children){
                                let fold_text = row.fold ? '展开' : '收起';
                                ret.push(h('span', {
                                    'class': {
                                        'color-info': row.fold,
                                        'color-grey': !row.fold,
                                        'pointer': true,
                                        'float-right': true
                                    },
                                    on: {
                                        click: ()=>{
                                            let type = this.fin_expense_types_hash[row.id];
                                            console.log(type);
                                            type.fold = !type.fold;
                                            this.genTableRows();
                                        }
                                    }
                                }, fold_text));
                            }
                            return h('div',{
                                'class': {
                                    'text-left': true
                                },
                                style: {
                                    paddingLeft: this.getPaddingLeft(row)
                                }
                            }, ret);
                        }
                    }
                ];
                this.export_columns = [
                    {
                        title: '费用类别',
                        key: 'name',
                        width: 190,
                        fixed: 'left',
                        align: 'center',
                        render: (h, params)=>{
                            let row = params.row;
                            return h('span', `${row.name} `);
                        }
                    }
                ];
                this.groups.forEach((group)=>{
                    let column = {
                        title: group.name,
                        align: 'center'
                    };
                    if(group.fin_teams.length){
                        column.children = [];
                        group.fin_teams.forEach((fin_team)=>{
                            const children_column = {
                                title: fin_team.name,
                                width: 110,
                                key: fin_team.id,
                                align: 'center',
                                render: (h, params)=>{
                                    return this.renderTd(h, params, fin_team);
                                }
                            };
                            column.children.push(children_column)
                            this.export_columns.push(children_column)
                        });
                        columns.push(column);
                    }
                });
                this.none_group_teams.forEach((fin_team)=>{
                    const none_group_column = {
                        title: fin_team.name,
                        key: fin_team.id,
                        width: 110,
                        align: 'center',
                        render: (h, params)=>{
                            return this.renderTd(h, params, fin_team);
                        }
                    };
                    columns.push(none_group_column)
                    this.export_columns.push(none_group_column)
                });
                const total_column = {
                    title: '合计',
                    key: 'total',
                    width: 110,
                    align: 'center',
                    fixed: 'right',
                    render: (h, params)=>{
                        return this.renderTdTotal(h, params);
                    }
                };
                columns.push(total_column);
                this.export_columns.push(total_column);
                return columns;
            },
            no_data_text(){
                if(this.table_rows.length || this.loading){
                    return '加载数据中...';
                }else{
                    return '暂无数据';
                }
            }
        },
        created(){
            //this.getFinTeams();
            this.getHeaderData();
            this.getFinExpenseTypes();
            this.init();
        },
        mounted(){
            //
        },
        methods: {
            init(){
                this.params.month = this.curMonth();
                this.params.daterange = this.curDaterange();
                this.getReport();
            },
            curMonth(){
                let now = moment();
                let year = now.year();
                let month = now.month() + 1;
                if(this.type === 'monthly'){
                    if(month === 1){
                        year = year - 1;
                        month = 12;
                    }else{
                        month = month - 1;
                    }
                }
                if(month < 10){
                    month = `0${month}`;
                }
                return `${year}-${month}`;
            },
            curDaterange(){
                if(this.params.daterange.length){
                    return this.params.daterange;
                }
                let now = Date.now() - 24 * 3600 * 1000;
                let today = Util.formatDate(now);
                return [today, today];
            },
            getFinTeams(){
                Util.ajax.get(Util.api.get_fin_teams, {
                    //
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        let data = res.data;
                        data.forEach((team)=>{
                            this.fin_teams.push(team);
                        });
                    }else{
                        this.$Modal.error({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    console.log(e);
                });
            },
            getHeaderData(){
                Util.ajax.get(Util.api.fin_report_header_data, {
                    //
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        let data = res.data;
                        this.groups = data.groups;
                        this.none_group_teams = data.teams;
                    }else{
                        this.$Modal.error({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    console.log(e);
                });
            },
            getFinExpenseTypes(){
                Util.ajax.get(Util.api.get_fin_expense_types, {
                    params: {version: 1}
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        let data = res.data;
                        this.genFinExpenseTypes(data, 0);
                        this.genTableRows();
                    }else{
                        this.$Modal.error({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    console.log(e);
                });
            },
            genFinExpenseTypes(fin_expense_types, layer){
                fin_expense_types.forEach((fet, index)=>{
                    if(this.type === 'dynamic_income' && index > 3 && !layer){
                        return;
                    }
                    if(!fet.is_hide){
                        fet.has_children = fet.fin_expense_types.length > 0;
                        fet.show = true;
                        fet.empty = false;
                        this.fin_expense_types.push(fet);
                        this.fin_expense_types_hash[fet.id] = fet;
                        if(fet.has_children){
                            this.genFinExpenseTypes(fet.fin_expense_types, layer + 1);
                        }
                    }
                });
            },
            genTableRows(){
                this.table_rows = [];
                if(!this.fin_expense_types.length || !Object.keys(this.fin_team_expense_hash).length){
                    return;
                }
                this.fin_expense_types.forEach((type)=>{
                    let parent_type = this.fin_expense_types_hash[type.parent_id];
                    if(parent_type && (parent_type.fold || !parent_type.show)){
                        type.show = false;
                    }else{
                        type.show = true;
                        //let type_data = {title: type.name, level: type.level, data_type: type.data_type};
                        let type_data = Util.clone(type);
                        let show_data = this.fin_team_expense_hash[type.id];
                        if(show_data){
                            Object.assign(type_data, show_data);
                            type_data.empty = false;
                        }else{
                            type_data.empty = true;
                        }
                        this.table_rows.push(type_data);
                    }
                });
                //this.genTableColumns();
            },
            genTableColumns(){
                this.table_columns = [
                    {
                        title: '费用类别',
                        key: 'name',
                        width: 170,
                        fixed: 'left',
                        align: 'center',
                        renderHeader: (h, params)=>{
                            let ret = [];
                            if(this.type === 'monthly'){
                                ret = [
                                    h('DatePicker', {
                                        attrs: {
                                            style: 'width: 100px',
                                            placeholder: '选择月份',
                                        },
                                        props: {
                                            size: 'small',
                                            type: 'month',
                                            value: this.curMonth(),
                                            options: {
                                                disabledDate(date){
                                                    let now = new Date();
                                                    let disabledDateStart = new Date('2017-08-31').getTime();
                                                    let disabledDateEnd = new Date(`${now.getFullYear()}-${now.getMonth()}-01`).getTime();
                                                    return date && ( date.valueOf() < disabledDateStart || date.valueOf() > disabledDateEnd);
                                                }
                                            }
                                        },
                                        on: {
                                            'on-change': (month)=>{
                                                this.params.month = month;
                                                this.getReport();
                                            }
                                        }
                                    }),
                                    h('span', ' '),
                                    h('Button', {
                                        props: {
                                            size: 'small',
                                            type: 'primary'
                                        },
                                        on: {
                                            click: ()=>{
                                                this.getReport();
                                            }
                                        }
                                    }, '确定')
                                ];
                            }else if(this.type === 'dynamic'){
                                let now = moment();
                                let start = `${now.year()}-${now.month()+1}-01`;
                                let end = now.format('YYYY-MM-DD');
                                ret = `${start} 至 ${end}`;
                            }else{
                                ret = '未定义仪表盘类型';
                            }

                            return h('div', ret);
                        },
                        render: (h, params)=>{
                            let row = params.row;
                            let ret = [];
                            ret.push(h('span', `${row.name} `));
                            if(row.name_tip){
                                ret.push(h('Tooltip', {
                                    props: {
                                        content: row.name_tip,
                                        transfer: true,
                                        placement: 'top'
                                    }
                                }, [
                                    h('Icon', {
                                        props: {
                                            type: 'md-help-circle',
                                            size: 12
                                        }
                                    })
                                ]));
                            }
                            if(row.has_children){
                                let fold_text = row.fold ? '展开' : '收起';
                                ret.push(h('span', {
                                    'class': {
                                        'color-info': row.fold,
                                        'color-grey': !row.fold,
                                        'pointer': true,
                                        'float-right': true
                                    },
                                    on: {
                                        click: ()=>{
                                            let type = this.fin_expense_types_hash[row.id];
                                            console.log(type);
                                            type.fold = !type.fold;
                                            this.genTableRows();
                                        }
                                    }
                                }, fold_text));
                            }
                            return h('div',{
                                'class': {
                                    'text-left': true
                                },
                                style: {
                                    paddingLeft: this.getPaddingLeft(row)
                                }
                            }, ret);
                        }
                    }
                ];
                this.groups.forEach((group)=>{
                    let column = {
                        title: group.name,
                        align: 'center'
                    };
                    if(group.fin_teams.length){
                        column.children = [];
                        group.fin_teams.forEach((fin_team)=>{
                            column.children.push({
                                title: fin_team.name,
                                width: 110,
                                align: 'center',
                                render: (h, params)=>{
                                    let row = params.row;
                                    let val = params.row[fin_team.id] || 0;
                                    let ret = Util.formatPrice(val);
                                    if(row.data_type === 'int'){
                                        ret = Util.formatNumber(val);
                                    }
                                    if(!val || ret === '0.00' || ret === '0'){
                                        ret = '-';
                                    }
                                    return h('div', {
                                        'class': {
                                            'text-right': true
                                        }
                                    }, ret);
                                }
                            })
                        });
                        this.table_columns.push(column);
                    }
                });
                this.none_group_teams.forEach((fin_team)=>{
                    this.table_columns.push({
                        title: fin_team.name,
                        key: fin_team.id,
                        width: 110,
                        align: 'center',
                        render: (h, params)=>{
                            let row = params.row;
                            let val = params.row[fin_team.id] || 0;
                            let ret = Util.formatPrice(val);
                            if(row.data_type === 'int'){
                                ret = Util.formatNumber(val);
                            }
                            if(!val || ret === '0.00' || ret === '0'){
                                ret = '-';
                            }
                            return h('div', {
                                'class': {
                                    'text-right': true
                                }
                            }, ret);
                        }
                    })
                });
                this.table_columns.push({
                    title: '合计',
                    key: 'total',
                    width: 110,
                    align: 'center',
                    fixed: 'right',
                    render: (h, params)=>{
                        let row = params.row;
                        let total = Util.formatPrice(row.total);
                        if(row.data_type === 'int'){
                            total = Util.formatNumber(row.total);
                        }
                        if(total === '0.00' || total === '0'){
                            total = '-';
                        }
                        return h('div', {
                            'class': {
                                'text-right': true
                            }
                        }, total);
                    }
                });
            },
            validParams(){
                if(this.type === 'dynamic_income'){
                    if(this.params.daterange.length === 0){
                        this.$Modal.error({
                            title: '提示',
                            content: '请选择正确的日期范围'
                        });
                        return false;
                    }
                }else{
                    if(!this.params.month){
                        this.$Modal.error({
                            title: '提示',
                            content: '请选择正确的月份'
                        });
                        return false;
                    }
                }
                return true;
            },
            getReportUrl(){
                if(this.type === 'dynamic_income'){
                    return Util.api.fin_report_dynamic_income;
                }else{
                    return Util.api.fin_report_month_report;
                }
            },
            getReport(){
                if(this.loading) return;
                if(!this.validParams()) return;
                this.table_rows = [];
                this.fin_team_expense_hash = {};
                this.loading = true;
                Util.ajax.get(this.getReportUrl(), {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((data)=>{
                    console.log(data);
                    this.loading = false;
                    if(data.code === 1){
                        this.genTableData(data.data);
                        this.genTableRows();
                    }else{
                        this.$Modal.warning({
                            title: '提示',
                            content: data.msg
                        })
                    }
                }).catch((e)=>{
                    this.loading = false;
                    console.log(e);
                    this.$Message.error('获取数据失败, 请重试!');
                });
            },
            genTableData(fin_team_expenses){
                if(fin_team_expenses.length === 0){
                    this.$Message.warning('没有数据');
                    return;
                }
                let hash = {};
                fin_team_expenses.forEach((fin_team_expense)=>{
                    let fin_expense_type_id = fin_team_expense.fin_expense_type_id;
                    let type_hash = hash[fin_expense_type_id];
                    if(!type_hash){
                        type_hash = hash[fin_expense_type_id] = {total: 0};
                    }
                    let price = fin_team_expense.price;
                    type_hash[fin_team_expense.fin_team_id] = price;
                    if(price){
                        type_hash.total = math.eval(`${type_hash.total} + ${price}`).toFixed(2);
                    }
                });
                //手动调整平均售价
                try{
                    if(math.eval(`${hash[53]['total']} > 0`)){
                        hash[54]['total'] = math.eval(`(${hash[118]['total']} + ${hash[66]['total']}) / (${hash[53]['total']} - ${hash[115]['total']})`).toFixed(2);
                        hash[119]['total'] = math.eval(`${hash[118]['total']} / (${hash[53]['total']} - ${hash[115]['total']})`).toFixed(2);
                    }else{
                        hash[54]['total'] = '0';
                        hash[119]['total'] = '0';
                    }
                }catch(e){
                    console.warn(e);
                }
                this.fin_team_expense_hash = hash;
                this.fixTableRenderError();
            },
            calcRowTotal(row){
                let total = '0';
                Object.keys(row).forEach((key)=>{
                    if(Util.isNumber(key)){
                        total = math.eval(`${total} + ${row[key]}`).toFixed(2);
                    }
                });
                return total;
            },
            getExpenseTypeName(id){
                let type = this.fin_expense_types_hash[id];
                if(type){
                    return type.name;
                }else{
                    return '未识别费用类别';
                }
            },
            getPaddingLeft(row){
                let val = 0;
                switch (row.level){
                    case 1:
                        val = '8px';
                        break;
                    case 2:
                        val = '16px';
                        break;
                    case 3:
                        val = '24px';
                        break;
                    case 4:
                        val = '32px';
                        break;
                    default:
                        val = '0px';
                        break;
                }
                return val;
            },
            rowClassName (row, index) {
                return `fin-report-${row.level}-row row-${row.bg_color}`;
            },
            renderTd(h, params, fin_team){
                let row = params.row;
                let val = params.row[fin_team.id] || 0;
                let is_negative = math.eval(`${val} < 0`);
                let ret = '';
                if(row.data_type === 'int'){
                    //ret = is_negative ? `(${Util.formatNumber(math.abs(val))})` : Util.formatNumber(val);
                    ret = Util.formatNumber(val);
                }else{
                    //ret = is_negative ? `(${Util.formatPrice(math.abs(val))})` : Util.formatPrice(val);
                    ret = Util.formatPrice(val);
                }
                if(!val || ret === '0.00' || ret === '0'){
                    ret = '-';
                }
                return h('div', {
                    'class': {
                        'text-right': true,
                        'color-error': is_negative
                    }
                }, ret);
            },
            renderTdTotal(h, params){
                let row = params.row;
                let total = row.total || 0;
                let is_negative = math.eval(`${total} < 0`);
                if(row.data_type === 'int'){
                    total = Util.formatNumber(total);
                }else{
                    total = Util.formatPrice(total);
                }
                if(total === '0.00' || total === '0'){
                    total = '-';
                }
                return h('div', {
                    'class': {
                        'text-right': true,
                        'color-error': is_negative
                    }
                }, total);
            },
            fixTableRenderError(){
                this.$nextTick(()=>{
                    let table_body = this.$el.querySelector('.ivu-table-body');
                    if(table_body){
                        let scrollTop = table_body.scrollTop;
                        if(scrollTop > 0){
                            table_body.scrollTop = scrollTop - 1;
                        }
                    }
                });
            },
            exportCsv(){
                this.$refs.table.exportCsv({
                    filename: `仪表盘-${this.params.month}.csv`,
                    columns: this.export_columns,
                    data: this.table_rows
                });
            }
        }
    }
</script>
